import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import axios from "axios";
import "ag-grid-enterprise/styles/ag-theme-alpine.css";
import "ag-grid-enterprise/styles/ag-grid.css";
import { Modal, Form, Input, Button, Select, Checkbox, notification, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import './App.css'
import { API_ENDPOINT_GET_CC_DATA, API_ENDPOINT_REMOVE_CC, API_ENDPOINT_VENDORS } from "../vendorfollowup.constants";
import ScheduleCCFeature from "../ScheduleLeftPortion/ScheduleCCFeature";
import EmailPreviewSection from "./EmailPreviewSection";
import CCDetailsTable from "./DetailsTable";

const ContactPopup = ({ message, emoji, onClose }) => {
  

  return (
    <div className="popup-container">
      <div className="popup-content">
        <span className="popup-emoji">{emoji}</span>
        <p>{message}</p>
        <Button type="primary" onClick={onClose}>
          Close
        </Button>
      </div>
    </div>
  );
};



const AddCCModal = ({ visible, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [includeAllOptions, setIncludeAllOptions] = useState(false);
  const currentWorkspace = localStorage.getItem("currentWorkspace");

  const handleAddCC = async (values) => {
    setLoading(true);
    try {
      const authToken = localStorage.getItem("token");

      if (!authToken) {
        setLoading(false);
        notification.error({ message: "Authentication token not found." });
        return;
      }

      const payload = {
        ...values,
        vendors: selectedVendors,
        includeAllOptions,
      };

      const response = await axios.post(
        `https://fuzzyapi.finkraftai.com/add-cc/${currentWorkspace}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.data.status) {
        const newRow = {
          name: values.name,
          email: values.email,
          vendors: selectedVendors.join(", "),
        };
        onSuccess(newRow);
        form.resetFields();
        setSelectedVendors([]);
        setSelectAll(false);
        setIncludeAllOptions(false);
        onClose();
      } else {
        const newRow = {
          name: values.name,
          email: values.email,
          vendors: selectedVendors.join(", "),
        };
        onSuccess(newRow);
        form.resetFields();
        setSelectedVendors([]);
        setSelectAll(false);
        setIncludeAllOptions(false);
        onClose();
      }
    } catch (error) {
      console.error("Error adding CC:", error);
      notification.error({ message: "An error occurred while adding the contact." });
    } finally {
      setLoading(false);
    }
  };

  const handleVendorChange = (selectedItems) => {
    setSelectedVendors(selectedItems);
    setSelectAll(selectedItems.length === vendorList.length);
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);
    setSelectedVendors(isChecked ? vendorList.map((vendor) => vendor.value) : []);
  };

  const handleAllOptionsChange = (e) => {
    setIncludeAllOptions(e.target.checked);
  };



  useEffect(() => {
    const fetchVendors = async () => {
      try {
          const response = await fetch(API_ENDPOINT_VENDORS, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ workspace: currentWorkspace }),
        });
  
        const data = await response.json();
        if (data.status === "success") {
          const formattedVendors = data.vendors.map((vendor) => ({
            value: vendor,
            label: vendor,
          }));
          setVendorList(formattedVendors);
        }
      } catch (error) {
        console.error("Error fetching vendor data:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchVendors();
  }, []);
  

   

  const [vendorList, setVendorList] = useState([]);


  return (
    <Modal
      title="Add CC"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={500}
    >
      <Form form={form} layout="vertical" onFinish={handleAddCC}>
        <Form.Item
          label="CC Name"
          name="name"
          rules={[{ required: true, message: "Please enter the CC name." }]}
        >
          <Input placeholder="Enter CC name" />
        </Form.Item>
        <Form.Item
          label="CC Email"
          name="email"
          rules={[
            { required: true, message: "Please enter the CC email." },
            { type: "email", message: "Please enter a valid email address." },
          ]}
        >
          <Input placeholder="Enter CC email" />
        </Form.Item>
        <Form.Item label="Select Vendor">
          <Checkbox onChange={handleSelectAll} checked={selectAll}>
            Select All
          </Checkbox>
          <Checkbox onChange={handleAllOptionsChange} checked={includeAllOptions}>
            Include All Options
          </Checkbox>
          <Select
            mode="multiple"
            placeholder="Select vendors"
            showSearch
            optionFilterProp="children"
            value={selectedVendors}
            onChange={handleVendorChange}
            style={{ width: "100%" }}
          >
            {vendorList.map((vendor) => (
              <Select.Option key={vendor.value} value={vendor.value}>
                {vendor.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item style={{ marginTop: "20px" }}>
          <Button type="primary" htmlType="submit" loading={loading}>
            Submit
          </Button>
          <Button onClick={onClose} style={{ marginLeft: "10px" }}>
            Cancel
          </Button>
        </Form.Item>
      </Form>
    </Modal>
 

  );
};

const ScheduleFollowUps = () => {
  const [rowData, setRowData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState(""); 

  

  const vendorList = [
    { value: "vendor1", label: "Vendor 1" },
    { value: "vendor2", label: "Vendor 2" },
    { value: "vendor3", label: "Vendor 3" },
  ];

  const fetchUserData = async () => {
    const authToken = localStorage.getItem("token");

    if (!authToken) {
      alert("Authentication token not found.");
      return;
    }

    try {
      const currentWorkspace = localStorage.getItem("currentWorkspace");
      const response = await axios.get(
        `${API_ENDPOINT_GET_CC_DATA}?workspaceid=${currentWorkspace}`,
        //`https://fuzzyapi.finkraftai.com/get-cc-data?workspaceid=${currentWorkspace}`,
        // `http://localhost:5000/get-cc-data?workspaceid=${currentWorkspace}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.data.status) {
        const formattedData = response.data.data.map((item) => ({
          name: item.name,
          email: item.email,
          vendors: item.vendors || "", // Vendors should already be a comma-separated string
        }));

        setRowData(formattedData);
      } else {
        console.error("Failed to fetch data: ", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching user data: ", error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const handleAddSuccess = (newRow) => {
    setRowData((prevRowData) => [...prevRowData, newRow]);
    setPopupMessage("CC Added Successfully!");
    setShowPopup(true);
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const handleModalClose = () => {
    setShowModal(false);
  };
  const  handleRemoveCC=async (ccData) => {
    const authToken = localStorage.getItem("token");
    const currentWorkspace = localStorage.getItem("currentWorkspace");
    if (!authToken) {
      alert("Authentication token not found.");
      return;
    }
  
    try {
      // Assumes your new endpoint is '/remove-cc' and expects query params for workspace and email
      const response = await axios.delete(
        API_ENDPOINT_REMOVE_CC,
        {
          headers: { Authorization: `Bearer ${authToken}` },
          params: {
            workspaceid: currentWorkspace,
            email: ccData.email,
          },
        }
      );
      
      if (response.data.status) {
        // Update the grid by filtering out the removed CC
        setRowData((prevData) =>
          prevData.filter((item) => item.email !== ccData.email)
        );
        // Optionally, show a success popup
        setPopupMessage("CC Removed Successfully!"); // Set remove success message
        setShowPopup(true);
      } else {
        console.error("Failed to remove CC: ", response.data.message);
      }
    } catch (error) {
      console.error("Error removing CC: ", error);
    }
  };
  

  const [columnDefs, setColumnDefs] = useState([
    { headerName: "Name", field: "name" },
    { headerName: "Email", field: "email" },
    { headerName: "Vendors", field: "vendors" },
    {
      headerName: "Remove",
      cellRenderer: (params) => {
        return (
          <Button
           
            onClick={() => handleRemoveCC(params.data)}
          >
            Remove
          </Button>
        );
      },
    },
  ]);



 
  const [showDetails, setShowDetails] = useState(false)
  const handleViewMoreClick = () => {
    setShowDetails(true);
  };

  return (
     <>  
       {/* <button onClick={handleViewMoreClick}>View More</button> */}
        {showDetails ? (
          <CCDetailsTable />
        ) : (
        
          <div className="schedule-followups-container" style={{display:"flex",gap:'20px',flex:1}}>
            <div style={{width:'40%',display:'flex'}}>
            <ScheduleCCFeature setShowDetails={setShowDetails}/>
            </div>
            
            <div style={{width:'60%',display:'flex'}}>
            <EmailPreviewSection />
            </div>
           {/* <div style={{ backgroundColor: 'red', width: '40%' }}>1</div>
           <div style={{ backgroundColor: 'yellow', width: '60%' }}>2</div> */}
            
            </div>
          
        )}
         
      <AddCCModal
        visible={showModal}
        onClose={handleModalClose}
        onSuccess={handleAddSuccess}
        vendorList={vendorList}
      />
      {showPopup && (
        <ContactPopup
          message={popupMessage}
          emoji="🎉"
          onClose={() => setShowPopup(false)}
        />
      )}
    </>
   
  );
}


export default ScheduleFollowUps;

